<div class="min-h-screen bg-[--color-cloud-mist] flex flex-col">

  <!-- Admin banner -->
  @if (currentUser()) {
    <div class="bg-[--color-midnight-indigo] text-white text-sm px-4 py-2 flex items-center justify-between">
      <span>Modo mantenimiento activo — estás viendo la página pública.</span>
      <a routerLink="/dashboard" class="font-semibold underline hover:no-underline">Ir al dashboard →</a>
    </div>
  }

  <main class="flex-1 flex items-center justify-center px-4 py-16">
    <div class="w-full max-w-lg text-center">

      <!-- Icon -->
      <div class="mx-auto mb-8 w-20 h-20 rounded-2xl bg-[--color-pale-gray] flex items-center justify-center">
        <svg class="w-10 h-10 text-[--color-action-blue]" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l5.654-4.654m5.896-3.42c.34-.17.69-.34 1.036-.51l3.285 3.284c-.172.347-.344.695-.512 1.04M6.182 7.636l3.536 3.536M6.182 7.636C4.964 6.418 4.4 4.9 4.4 3.4 4.4 2.628 5.028 2 5.8 2c1.5 0 3.018.564 4.236 1.782l3.536 3.536M6.182 7.636 3 10.818" />
        </svg>
      </div>

      <!-- Content -->
      @if (loading()) {
        <div class="h-6 w-48 bg-[--color-pale-gray] rounded-lg animate-pulse mx-auto mb-4"></div>
        <div class="h-4 w-72 bg-[--color-pale-gray] rounded-lg animate-pulse mx-auto"></div>
      } @else {
        <h1 class="text-[--text-heading-lg] font-bold text-[--color-midnight-indigo] mb-3 leading-tight">
          Estamos haciendo mejoras
        </h1>
        <p class="text-[--text-body-lg] text-[--color-slate-blue] mb-6 leading-relaxed">
          {{ config()?.maintenanceMessage || 'Estamos realizando mejoras. Volvemos pronto.' }}
        </p>

        @if (config()?.maintenancePlannedEnd) {
          <div class="inline-flex items-center gap-2 bg-white border border-[--color-pale-gray] rounded-xl px-4 py-3 text-sm text-[--color-slate-blue] mb-8">
            <svg class="w-4 h-4 text-[--color-action-blue] shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            <span>Vuelta prevista: <strong>{{ formatDate(config()?.maintenancePlannedEnd) }}</strong></span>
          </div>
        }
      }

      <!-- Animated dots -->
      <div class="flex justify-center gap-2 my-8">
        <span class="w-2.5 h-2.5 rounded-full bg-[--color-action-blue] animate-bounce" style="animation-delay:0ms"></span>
        <span class="w-2.5 h-2.5 rounded-full bg-[--color-action-blue] animate-bounce" style="animation-delay:150ms"></span>
        <span class="w-2.5 h-2.5 rounded-full bg-[--color-action-blue] animate-bounce" style="animation-delay:300ms"></span>
      </div>

      <!-- Logo -->
      <div class="flex items-center justify-center gap-2 mb-1">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 76" class="h-7 w-auto">
          <path fill="#0B3558" d="M36,56.45q12.25,0,24.49,0a8.19,8.19,0,0,1,5.76,2.11,7.75,7.75,0,0,1,2.29,3.83,7.51,7.51,0,0,1-1,6.32,7.87,7.87,0,0,1-5.93,3.64,32.31,32.31,0,0,1-3.55.07,1.23,1.23,0,0,0-.82.29c-1.44,1.19-2.9,2.37-4.36,3.54l-5.09,4c-.91.73-1.81,1.47-2.74,2.18A2.7,2.7,0,0,0,44,84.74q0,10.53,0,21.08c0,1.27,0,2.55,0,3.82A7.76,7.76,0,0,1,41.29,115a7.56,7.56,0,0,1-6.3,2,7.67,7.67,0,0,1-5.56-3.38A8,8,0,0,1,28,109c0-7.55,0-15.11,0-22.67a3,3,0,0,0-1.67-2.83c-1.89-1.11-3.73-2.31-5.6-3.47S16.91,77.65,15,76.48a6.51,6.51,0,0,1-2.91-3.61c-.11-.33-.25-.48-.63-.47a8.13,8.13,0,0,1-6.24-2.55,7.52,7.52,0,0,1-1.86-3.3,7.73,7.73,0,0,1-.18-3.41,7.85,7.85,0,0,1,3.74-5.53,8.87,8.87,0,0,1,4.8-1.17Z" transform="translate(0 -40.31)"/>
        </svg>
        <span class="text-lg font-extrabold text-[--color-midnight-indigo] tracking-tight">TimeFlexRent</span>
      </div>
      <p class="text-xs text-[--color-steel-gray]">La plataforma de alquiler de espacios flexibles</p>
    </div>
  </main>

  <!-- Admin login link at bottom -->
  <footer class="py-4 text-center">
    <a routerLink="/login"
       class="text-xs text-[--color-steel-gray] hover:text-[--color-slate-blue] transition-colors">
      Acceso administrador
    </a>
  </footer>

</div>
